import React from "react";
import produce from "immer";
import IconSelector from "../refresh/selectors/IconSelector";
import TextInput from "../refresh/inputs/TextInput";
import Checkbox from "../refresh/inputs/Checkbox";

const GenericOptions = ({
  config,
  setConfig,
  account,
  icon,
  iconSet,
  title = true,
  template = false,
  hideIcon = false,
  requireTooltip = true,
}) => {
  return (
    <>
      <h1>Options</h1>
      <TextInput
        label="tooltip"
        required={requireTooltip}
        value={config.tooltip}
        onChange={tooltip =>
          setConfig(
            produce(c => {
              c.tooltip = tooltip;
            }),
          )
        }
      />
      {!template && (
        <Checkbox
          value={config.permaTooltip}
          onChange={checked =>
            setConfig(
              produce(c => {
                c.permaTooltip = checked;
              }),
            )
          }
        >
          Make tooltip visible at all times
        </Checkbox>
      )}
      {title && (
        <TextInput
          label="title"
          required
          value={config.options.title}
          onChange={title =>
            setConfig(
              produce(c => {
                c.options.title = title;
              }),
            )
          }
        />
      )}
      {!hideIcon && (
        <IconSelector
          template={template}
          value={config.icon}
          account={account}
          set={iconSet ?? [icon]}
          defaultIcon={icon}
          onChange={icon =>
            setConfig(
              produce(c => {
                c.icon = icon;
              }),
            )
          }
        />
      )}
    </>
  );
};

export default GenericOptions;
